const SvgAi2 = (props) => (
  <>
    <path
      d="M103.98 223.6c26.23-2.6 48.72-17.87 61.29-39.6M96 64c44.18 0 80 35.82 80 80 0 14.58-3.92 28.23-10.73 40M96 64c-44.18 0-80 35.82-80 80 0 14.58 3.92 28.23 10.73 40M88.02 223.6C61.79 221 39.3 205.73 26.73 184M103.98 144.4c26.23 2.6 48.72 17.87 61.29 39.6M165.27 264c6.81-11.77 10.73-25.42 10.73-40s-3.92-28.23-10.73-40M26.73 184C19.92 195.77 16 209.42 16 224s3.92 28.23 10.73 40M88.02 144.4C61.79 147 39.3 162.27 26.73 184M88.02 303.6C61.79 301 39.3 285.73 26.73 264M103.98 303.6c26.23-2.6 48.72-17.87 61.29-39.6M88.02 224.4C61.79 227 39.3 242.27 26.73 264"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
    <path
      d="M165.27 264A79.605 79.605 0 0 1 176 304c0 44.18-35.82 80-80 80s-80-35.82-80-80c0-14.58 3.92-28.23 10.73-40M103.98 224.4c26.23 2.6 48.72 17.87 61.29 39.6"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
    <path
      d="M103.98 303.6c0 .13.02.26.02.4 0 4.42-3.58 8-8 8s-8-3.58-8-8c0-.13.01-.27.02-.4M103.98 303.6c-.21-4.23-3.7-7.6-7.98-7.6s-7.77 3.37-7.98 7.6M103.98 144.4c0-.13.02-.26.02-.4 0-4.42-3.58-8-8-8M103.98 144.4c-.21 4.23-3.7 7.6-7.98 7.6s-7.77-3.37-7.98-7.6M88.02 144.4c0-.13-.02-.26-.02-.4 0-4.42 3.58-8 8-8M103.98 224.4c0-.13.02-.26.02-.4s-.01-.27-.02-.4M88.02 223.6c0 .13-.02.26-.02.4s.01.27.02.4M103.98 223.6c-.21-4.23-3.7-7.6-7.98-7.6s-7.77 3.37-7.98 7.6M103.98 224.4c-.21 4.23-3.7 7.6-7.98 7.6s-7.77-3.37-7.98-7.6M96 64v72M96 64V0"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
  </>
);

export default SvgAi2;
